import { CargarDocumentModalForm } from "./CargarDocumentModalForm"


const CargarDocumentModalFormWrapper = () => {
    return (<CargarDocumentModalForm />)
}

export {CargarDocumentModalFormWrapper}